import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap"; // Corrected Import
import { addTrainer } from '../../lib/api';
import { toast } from 'react-toastify';

export const TrainingRightsSection = ({ selectedUser, setShowTrainingRights }) => {
    const [trainingRights, setTrainingRights] = useState({
        CanTrainerRegNewFarmers: false,
        CanTrainerViewAllFarmers: false,
        CanTrainerViewOwnRegFarmer: false,
    });

    const token = localStorage.getItem('token') || '';

    useEffect(() => {
        if (!selectedUser) return;

        setTrainingRights({
            CanTrainerRegNewFarmers: Boolean(selectedUser.CanTrainerRegNewFarmers),
            CanTrainerViewAllFarmers: Boolean(selectedUser.CanTrainerViewAllFarmers),
            // Logic: If they can reg or view all, they automatically view own
            CanTrainerViewOwnRegFarmer:
                Boolean(selectedUser.CanTrainerRegNewFarmers) ||
                Boolean(selectedUser.CanTrainerViewAllFarmers) ||
                Boolean(selectedUser.CanTrainerViewOwnRegFarmer),
        });
    }, [selectedUser]);

    const handleCheckboxChange = (key, value) => {
        setTrainingRights(prev => {
            let updated = { ...prev, [key]: value };
            
            // Side effect: If either of these are true, 'Own' must be true
            if (key === 'CanTrainerRegNewFarmers' || key === 'CanTrainerViewAllFarmers') {
                if (value === true) {
                    updated.CanTrainerViewOwnRegFarmer = true;
                }
            }
            return updated;
        });
    };

    const handleSaveRights = async () => {
        try {
            // A user is a trainer if ANY right is selected
            const isTrainer =
                trainingRights.CanTrainerRegNewFarmers ||
                trainingRights.CanTrainerViewAllFarmers ||
                trainingRights.CanTrainerViewOwnRegFarmer;

            const payload = {
                FarmerID: selectedUser.FarmerID || selectedUser.ID,
                IsThisATrainer: isTrainer,
                CanTrainerRegNewFarmers: trainingRights.CanTrainerRegNewFarmers,
                CanTrainerViewAllFarmers: trainingRights.CanTrainerViewAllFarmers,
                CanTrainerViewOwnRegFarmer: isTrainer, // Usually matches IsThisATrainer
            };

            await addTrainer(token, payload);
            toast.success('Training rights saved successfully');
            setShowTrainingRights(false); // Close after success
        } catch (error) {
            console.error(error);
            toast.error('Failed to save training rights');
        }
    };

    const handleRemoveRights = async () => {
        try {
            const payload = {
                FarmerID: selectedUser.FarmerID || selectedUser.ID,
                IsThisATrainer: false,
                CanTrainerRegNewFarmers: false,
                CanTrainerViewAllFarmers: false,
                CanTrainerViewOwnRegFarmer: false,
            };

            await addTrainer(token, payload);
            setTrainingRights({
                CanTrainerRegNewFarmers: false,
                CanTrainerViewAllFarmers: false,
                CanTrainerViewOwnRegFarmer: false,
            });
            toast.success('Training rights removed successfully');
            setShowTrainingRights(false);
        } catch (error) {
            toast.error('Failed to remove training rights');
        }
    };

    return (
        <div style={{ padding: '25px', backgroundColor: 'white', height: '100%', overflowY: 'auto' }}>
            <div className="d-flex justify-content-between align-items-center mb-4 pb-3"
                style={{ borderBottom: '1px solid #e0e0e0' }}>
                <h4 style={{ fontWeight: '600', margin: 0, color: '#000' }}>
                    Training Rights
                </h4>
                <button
                    onClick={() => setShowTrainingRights(false)}
                    style={{ border: 'none', background: 'none', color: '#000', padding: 0 }}
                >
                    <Icon icon="lucide:x" className="text-2xl" />
                </button>
            </div>

            <div className="p-4 mb-4" style={{ border: '1px solid #C8E6C9', borderRadius: '8px' }}>
                <Form.Check
                    type="checkbox"
                    id="reg-farmer"
                    label="Register A Farmer"
                    checked={trainingRights.CanTrainerRegNewFarmers}
                    onChange={(e) => handleCheckboxChange('CanTrainerRegNewFarmers', e.target.checked)}
                    className="mb-3 custom-checkbox"
                />

                <Form.Check
                    type="checkbox"
                    id="view-own"
                    label="View Registered Farmer (Own)"
                    checked={trainingRights.CanTrainerViewOwnRegFarmer}
                    disabled // Keep disabled as it's a derived right
                    className="mb-3"
                />

                <Form.Check
                    type="checkbox"
                    id="view-all"
                    label="View All Farmers"
                    checked={trainingRights.CanTrainerViewAllFarmers}
                    onChange={(e) => handleCheckboxChange('CanTrainerViewAllFarmers', e.target.checked)}
                    className="mb-3"
                />
            </div>

            <div className="d-flex gap-3 pt-3">
                <Button
                    variant="success"
                    onClick={handleSaveRights}
                    style={{ backgroundColor: '#1B5E20', borderColor: '#1B5E20', fontWeight: '600', flex: 1 }}
                >
                    Save Rights
                </Button>

                <Button
                    variant="dark"
                    onClick={handleRemoveRights}
                    style={{ fontWeight: '600', flex: 1 }}
                >
                    Remove Rights
                </Button>
            </div>
        </div>
    );
};